import { deleteRecord } from '@/entities/shared/record/delete-record';

export async function deleteTask(id: string): Promise<void> {
  await deleteRecord('tasks', id);
}
